
  Vue.component('seeker-lists-add-button', {
    props: {
      curriculumId: { type: Number, default: 0 },
      direction: { type: String, default: 'left' },
      fetchLists: { type: Boolean, default: false }
    },
    data() {
      return {
        showList: false
      }
    },
    pinia: Vue.pinia,
    template: '#seeker-lists-add-button',
    computed: {
      // seekerListsStore data
      ...Pinia.mapState(useSeekerListsStore, {
        loading: store => store.loading,
        lists: store => store.lists,
        selectedListsByCurriculumId: store => store.selectedListsByCurriculumId || {}
      }),

      selectedLists() {
        return (this.selectedListsByCurriculumId ? this.selectedListsByCurriculumId[this.curriculumId] : null) || []
      },

      selectedListsNames() {
        return this.selectedLists?.length
          ? _.filter(
              _.map(this.selectedLists, id => _.find(this.lists, list => list.Id === id)?.Name),
              x => !!x
            ).join(', ')
          : ''
      },

      isPinned() {
        return this.selectedLists?.length
      },

      dropdownDirectionClass() {
        return `drop${this.direction}`
      }
    },
    watch: {},
    methods: {
      // seekerListsStore actions
      ...Pinia.mapActions(useSeekerListsStore, [
        'addToList',
        'fetchSelectedListsByCurriculaIds',
        'refreshSeekerLists',
        'removeFromList'
      ]),
      ...Pinia.mapActions(useModalsStore, ['showNewSeekerListModal']),

      addRemoveFromList(listId) {
        if (this.isListSelected(listId))
          return this.removeFromList(listId, this.curriculumId)
            .then(this.fetchSelectedListsByCurriculaIds)
            .then(() => {
              this.showList = false
            })

        return this.addToList(listId, this.curriculumId)
          .then(this.fetchSelectedListsByCurriculaIds)
          .then(() => {
            this.showList = false
          })
      },

      toggleMenuList() {
        this.showList = !this.showList
      },

      createNewList() {
        this.showList = false
        this.showNewSeekerListModal(this.curriculumId)
      },

      isListSelected(listId) {
        return this.selectedLists.includes(listId)
      }
    },
    mounted() {
      if (this.fetchLists) {
        this.refreshSeekerLists().then(() => this.fetchSelectedListsByCurriculaIds([this.curriculumId]))
      }
    }
  })
